export default "__VITE_ASSET__CIMItrYx__"